import { render } from "./amenities.vue?vue&type=template&id=1778410a&scoped=true"
import script from "./amenities.vue?vue&type=script&lang=js"
export * from "./amenities.vue?vue&type=script&lang=js"

import "./amenities.vue?vue&type=style&index=0&id=1778410a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1778410a"

export default script